module.exports = __webpack_public_path__ + "20_vast.jpg?8c5643aa0fa807b7f3c2eea9fedfd8df";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/20_vast.jpg
// module id = 174
// module chunks = 0